export default __webpack_public_path__ + "static/media/footer_logo_mobile.f7822992.svg";